import { editorStore, useEditorSelector } from './editorStore';
import type { Device } from './editorStore';
import type { IconName } from '../components/ui/Icon';
import { Icon } from '../components/ui/Icon';

const devices: { value: Device; label: string }[] = [
  { value: 'desktop', label: 'Desktop' },
  { value: 'tablet', label: 'Tablet' },
  { value: 'phone', label: 'Phone' }
];

const deviceIcons: Record<Device, IconName> = {
  desktop: 'monitor',
  tablet: 'tablet',
  phone: 'phone'
};

export default function DevicePreview() {
  const device = useEditorSelector((state) => state.previewDevice);
  const setDevice = (next: Device) => editorStore.setDevice(next);

  return (
    <div className="device-preview" role="group" aria-label="Preview device">
      {devices.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`device-preview-button ${
            device === option.value ? 'device-preview-button--active' : ''
          }`}
          onClick={() => setDevice(option.value)}
          aria-label={option.label}
          title={option.label}
        >
          <Icon name={deviceIcons[option.value]} size={15} />
          <span className="device-preview-label">{option.label}</span>
        </button>
      ))}
    </div>
  );
}
